'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'dumpster-fire';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f794';
var svgPathData = ['M32 163.9l0 4.1c0 13.3 10.7 24 24 24l82.7 0 25.6-128-83 0C71 64 61.8 70.6 58.5 80.4L33.2 156.3c-.8 2.4-1.2 5-1.2 7.6zM57.7 240c.4 2.1 13.3 73.4 38.9 213.7 3 16.3 17.9 27.6 34.4 26.1S160 464.6 160 448l0-16 118 0c-3.9-16.1-6-32.8-6-49.9 0-39.6 18.2-81.1 39.5-115.8 5.4-8.8 11.3-17.6 17.7-26.3L57.7 240zm130-48l108.3 0 0-128-82.7 0-25.6 128zM344 64l0 128 24.9 0c10.4-11 21.3-21.8 32.8-32.1 11.7-10.4 26.3-15.7 40.9-15.9l-16-80-82.7 0zm131.7 0L497 170.6c4.4 4.1 8.7 8.3 12.9 12.6 23.8-16.3 56.3-14.5 78 5.5 .9 .8 1.7 1.6 2.6 2.4 10.1-2.8 17.5-12.1 17.5-23.1l0-4.1c0-2.6-.4-5.1-1.2-7.6L581.5 80.4C578.2 70.6 569 64 558.7 64l-83 0z', 'M518 226.5l-12.3 13.8s-24.5-29.4-38.9-40.7c-5.4-4.3-11.5-7.3-18.8-7.5s-14.6 2.3-20.3 7.5c-23.4 21.1-50 48.9-70.9 80.2-20.8 31.1-36.8 67.1-36.8 104.5 0 88.6 70.4 159.8 160 159.8 88.7 0 160-71.2 160-159.8 0-30-11-60.9-26.2-88.1-15.2-27.4-35.3-52.3-55-70.6-5.6-5.2-12.8-7.8-19.9-7.8-7.6 0-15.5 2.8-20.9 8.9zM480 496.2c-35.3 0-64-28.7-64-64 0-36.5 37-73 54.8-88.4 5.4-4.7 13.1-4.7 18.5 0 17.7 15.4 54.8 51.9 54.8 88.4 0 35.3-28.7 64-64 64z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDumpsterFire = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;